// Import: Middleware Action & Custom Types
import {
    CLEAN_CONSULTINGCHECKIMEI,
    CLEAN_CONSULTINGCHECKIMEI_ERROR,
} from "_models/redux/types";

// Action function
export const cleanConsultingCheckImeiAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_CONSULTINGCHECKIMEI,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_CONSULTINGCHECKIMEI_ERROR,
            payload: undefined,
        });
    }
};
